import * as React from "react";
import { Link } from "react-router-dom";
import { Modal, Button } from "antd";
import TrackedBolTermsConditionText from "./TrackedBolTermsConditionText/TrackedBolTermsConditionText";

export interface Props {
    children?: React.ReactNode
}

export interface State {
    showModal: boolean;
}

export default class TrackedBolTermsConditionsLink extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = { showModal: false };
    }

    showModal = () => {
        this.setState({ showModal: true });
    }

    hideModal = () => {
        this.setState({ showModal: false });
    }
    render() {
        return (
            <>
                <Link to="#" onClick={this.showModal}>
                    Terms and Conditions
                </Link>
                <Modal
                    width="60vw"
                    title="Terms & Conditions"
                    visible={this.state.showModal}
                    closable={true}
                    onCancel={this.hideModal}
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            Cancel
                        </Button>,
                    ]}>
                    <div style={{ height: '50vh', overflowY: 'scroll' }}>
                        <TrackedBolTermsConditionText />
                    </div>
                </Modal>
            </>
        );
    }
}
